import { ReactNode, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FlexBox, Stack, Align } from '@ardoq/layout';
import { colors, r8, s16, s24 } from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';
import { FIELD_SELECTOR } from './Field';
import { FormSize } from '../../types';

const SIDE_NOTE_WIDTH = '295px';

type SideNoteProps = {
  $alignSelf?: Align;
};

export const SideNote = styled(Stack).attrs({
  gap: 'medium',
})<SideNoteProps>`
  ${text2};
  background-color: ${colors.surfaceStatusNeutral};
  border-radius: ${r8};
  padding: ${s16} ${s24};
  color: ${colors.textSubtle};
  width: ${SIDE_NOTE_WIDTH};
  min-width: ${SIDE_NOTE_WIDTH};
  flex-shrink: 0;
  align-self: ${({ $alignSelf = 'flex-start' }) => $alignSelf};
`;

export const FieldsWrapperBody = styled(Stack).attrs({ gap: 'medium' })`
  flex: 1;
  & > ${FIELD_SELECTOR} {
    max-width: ${FormSize.DEFAULT};
    min-width: 320px;
  }
`;

export type FieldsWrapperProps = {
  sideNote?: ReactNode;
  alignSideNote?: Align;
  'aria-label'?: string;
};

export const FieldsWrapper = ({
  children,
  sideNote,
  alignSideNote,
  'aria-label': ariaLabel,
}: PropsWithChildren<FieldsWrapperProps>) => (
  <FlexBox gap="medium" role="group" aria-label={ariaLabel}>
    <FieldsWrapperBody>{children}</FieldsWrapperBody>
    {sideNote && <SideNote $alignSelf={alignSideNote}>{sideNote}</SideNote>}
  </FlexBox>
);
